import React from 'react'
import { IconContext } from "react-icons";
import { FaExternalLinkAlt } from "react-icons/fa";

function Project({ projectName, projectTitle, projectDesc, projectLink, projectTags}) {
  return (
    <div>
        <a href={projectLink}>
          <div className="bg-white border border-gray-200 rounded-lg shadow dark:bg-[#313131] dark:border-gray-700 h-[35rem] group relative overflow-hidden">
            <div
              className="h-full bg-cover w-full bg-center rounded-t-lg transform transition-transform duration-300 ease-out group-hover:scale-105"
              style={{
                backgroundImage: `linear-gradient(0deg, rgba(0,0,0,0.5) 0%, rgba(255,255,255,0) 100%), url(${projectName})`,
              }}
            >
              <div className="absolute bottom-0 px-4 py-4">
                <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  {projectTitle}
                </h5>
                <p className="mb-3 font-normal text-white">
                  {projectDesc}
                </p>
              </div>
            </div>
            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100 flex items-center justify-center">
              <div className="text-center text-white px-4">
                <ul className="flex flex-wrap gap-2">
                {projectTags.map((tag, index) => (
                    <li key={index} className="px-3 py-1 bg-[#313131] border border-white rounded">
                      {tag}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <IconContext.Provider value={{ color: "white", className: "global-class-name absolute top-0 right-0 m-4" }}>
              <div>
                <FaExternalLinkAlt />
              </div>
            </IconContext.Provider>
          </div>
        </a>
    </div>
  )
}

export default Project;
